const RESET_MARKER_KEY = "gc-auth-cookie-reset"
const RESET_VERSION = "2026-08-21-v1"

const isAuthCookieName = name => {
    return name.startsWith("CognitoIdentityServiceProvider.") || name === "idToken" || name === "accessToken"
}

const cookieNames = () => {
    return document.cookie
        .split("; ")
        .map(cookieStr => cookieStr.slice(0, cookieStr.indexOf("=")))
        .filter(name => name.length > 0)
}

const hasDuplicateAuthCookies = () => {
    const counts = {}
    for (const name of cookieNames()) {
        counts[name] = (counts[name] || 0) + 1
    }
    return Object.keys(counts).some(name => isAuthCookieName(name) && counts[name] > 1)
}

const purgeAuthCookies = domains => {
    const expiry = "expires=Thu, 01 Jan 1970 00:00:00 GMT"
    const uniqueDomains = [...new Set([undefined, ...domains])]

    for (const name of [...new Set(cookieNames().filter(isAuthCookieName))]) {
        for (const domain of uniqueDomains) {
            document.cookie = `${name}=; ${expiry}; path=/${domain ? `; domain=${domain}` : ""}`
        }
    }
}

const readMarker = () => {
    try {
        return localStorage.getItem(RESET_MARKER_KEY)
    } catch {
        const marker = document.cookie.split("; ").find(cookieStr => cookieStr.startsWith(`${RESET_MARKER_KEY}=`))
        return marker ? marker.slice(RESET_MARKER_KEY.length + 1) : null
    }
}

const writeMarker = () => {
    try {
        localStorage.setItem(RESET_MARKER_KEY, RESET_VERSION)
    } catch {
        document.cookie = `${RESET_MARKER_KEY}=${RESET_VERSION}; expires=Fri, 01 Jan 2100 00:00:00 GMT; path=/`
    }
}

export default function runAuthCookieReset() {
    try {
        const duplicates = hasDuplicateAuthCookies()

        if (readMarker() === RESET_VERSION && !duplicates) {
            return
        }

        const production = process.env.NODE_ENV === "production"

        const envDomain = (process.env.VUE_APP_MAIN_DOMAIN || "")
            .trim()
            .toLowerCase()
            .replace(/^[a-z][a-z\d+.-]*:\/\//, "")
            .replace(/\/.*$/, "")
            .replace(/:\d+$/, "")
            .replace(/^\./, "")

        purgeAuthCookies([production ? envDomain || undefined : "localhost", window.location.hostname])
        writeMarker()

        if (duplicates) {
            console.warn(
                "[auth-reset] cleared auth cookies present at two scopes — the CMSs on this host were writing sessions at different cookie scopes. If this repeats, check VUE_APP_MAIN_DOMAIN in both apps' configs."
            )
        } else {
            console.warn(`[auth-reset] one-time auth cookie reset ${RESET_VERSION} applied — please log in again`)
        }
    } catch (e) {
        console.error("[auth-reset] failed", e)
    }
}
